import * as A from '../actions/ssFormActions';

export const 
storeForm = (formName, value) => ({ type: A.STORE_SS_FORM, formName, value }),
storeFormField = (formName, fieldName, value) => ({ type: A.STORE_SS_FORM_FIELD, formName, fieldName, value }),
markFieldErrorCode = (errorCode, formName, formField) => ({ type: A.FORM_UTILS_MARK_FORM_FIELD_ERROR_CODE, formName, formField, errorCode }),
resetFormData = () => ({ type: A.RESET_SS_FORM_DATA }),
toggleRequiredField = (form, field) => ({ type: A.TOGGLE_REQUIRED_FORM_FIELD, payload: { form, field }});